import { Route } from "../../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/display/Route.js";
import { WeatherView } from "../../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/display/WeatherView.js";
import { Sensor } from "../../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/model/Sensor.js";
import { DateUtil } from "../../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/utils/DateUtil.js";
import { DataManager } from "../../model/DataManager.js";
import { VOCategory, VOGalleryList } from "../../model/DataStructure.js";
import { Resource } from "../../model/Resource.js";
import { Diagram } from "../Diagram.js";
import { GalleryList, MediaLookup } from "../GalleryList.js";
import { AbstractContentView } from "./AbstractContentView.js";
import { Language } from "../../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/model/Language.js";

export class LogbookContentView extends AbstractContentView {

    private _onDateChange = e5.Signal.create<[Date]>();

    private _listContainer: HTMLDivElement;
    private _mapContainer: HTMLDivElement;
    private _galleryList: GalleryList;
    private _map: SVGElement;
    private _mapWidth: number = 1670;
    private _mapHeight: number = 1670;
    private _weather: WeatherView;
    private _weatherContainer: HTMLDivElement;
    private _category: VOCategory = null;
    private _date: Date = new Date();
    private _routes: Route[] = [];
    private _diagram: Diagram;
    private _routeMosaic: Route = null;
    private _routeNansen: Route = null;
    private _iceExtentImages: { [key: string]: HTMLDivElement } = {};
    private _groupedList: boolean = true;
    private _point: HTMLDivElement;
    private _svgUnderlay: SVGForeignObjectElement;
    private _svgOverlay: SVGForeignObjectElement;
    private _mapViewboxActive = "0 660 2270 2000";
    private _mapViewboxSmall = "0 0 2270 2000";

    private _showMap: boolean = true;

    constructor(private _data: DataManager) {
        super();

        this.element.classList.add("live-content-view");
        this.element.innerHTML = `
        <div class="live-view-left">
            <div class="live-view-map switch-container active">
                <div class="live-view-map-corridor-button">
                    <span>${Language.translate("main.toast-predicted-route")}</span>
                    <div class="live-view-map-corridor-button-image icon-238"></div>
                </div>
                <div class="toggle icon-249"></div>
            </div>
            <div class="live-view-weather switch-container">
                <div class="toggle icon-249"></div>
            </div>
            <div class="live-view-diagram">
            </div>
            <div class="data-view">
                <div class="item distance">
                    <span class="value">0</span>
                    <span class="unit">km</span>
                    <span class="label">${Language.translate("main.graph-distance")}</span>
                    <span class="icon icon-608"></span>
                </div>
                <div class="item temperature">
                    <span class="value">0</span>
                    <span class="unit">°C</span>
                    <span class="label">${Language.translate("main.graph-temperature")}</span>
                    <span class="icon icon-760"></span>
                </div>
                <div class="item wind">
                    <span class="value">0</span>
                    <span class="unit">m/s</span>
                    <span class="label">${Language.translate("main.graph-wind")}</span>
                    <span class="icon icon-260"></span>
                </div>
                <div class="item ice-extent">
                    <span class="value">0</span>
                    <span class="unit">mio km²</span>
                    <span class="label">${Language.translate("main.graph-ice-extent")}</span>
                    <span class="icon icon-781"></span>
                </div>
            </div>
        </div>
        <div class="date-view">
            <span class="time"></span>
            <span class="date"></span>
        </div>
        <div class="live-list-container"></div>
        `;
        this._listContainer = this.element.querySelector(".live-list-container");
        this._mapContainer = this.element.querySelector(".live-view-map");
        this._weatherContainer = this.element.querySelector(".live-view-weather");

        this._galleryList = new GalleryList();
        this._listContainer.appendChild(this._galleryList.element);
        this._galleryList.onRequestGallery.add(this.onRequestGallery.dispatch, this.onRequestGallery);

        this._weather = new WeatherView(this._data.pwa);
        this._weather.overrideTimeWithNow = false;
        this._weatherContainer.prepend(this._weather.element);

        this._diagram = new Diagram(this._data.pwa, this._data.config);
        this._diagram.onResize.enabled = false;
        this._diagram.onChange.add((graphValue) => {
            this.date = graphValue.date;
        });
        this.element.querySelector(".live-view-diagram").appendChild(this._diagram.element);

        $(this.element).on("click", ".switch-container:not(.active)", () => {
            this.showMap = !this.showMap;
        });

        this.onCloseGallery.add((galleryListGrouped, galleryIndex, mediaIndex) => {
            if (this._groupedList) {
                this._galleryList.show(galleryIndex, mediaIndex);
                return;
            }

            var lookup = this.mediaToUngrouped(galleryIndex, mediaIndex);
            if (lookup) {
                this._galleryList.show(lookup.galleryIndex, lookup.mediaIndex);
            }
        });

        this._onDateChange.debounce((date) => {
            var galleryList = this.getListData();
            for (var gallery of galleryList.all) {
                if (this._groupedList) {

                    for (var m of gallery.list_item_medias) {
                        if (DateUtil.greaterEqual(m.date, date)) {
                            this._galleryList.onChangeTop.cancel();
                            this._galleryList.onChangeTop.enabled = false;
                            this._galleryList.show(gallery.index, m.index);
                            this._galleryList.onChangeTop.enabled = true;
                            return;
                        }
                    }
                } else {
                    if (DateUtil.greaterEqual(gallery.date, date)) {
                        this._galleryList.onChangeTop.cancel();
                        this._galleryList.onChangeTop.enabled = false;
                        this._galleryList.show(gallery.index);
                        this._galleryList.onChangeTop.enabled = true;
                        return;
                    }
                }
            }
        }, 500);

        this._galleryList.onChangeTop.debounce((item) => {
            var media = item.media;
            var date = media ? media.date : item.gallery.date;
            if (date) {
                this._onDateChange.cancel();
                this._onDateChange.enabled = false;
                this.date = date;
                this._onDateChange.enabled = true;
            }
        }, 500);
    }

    private get showMap(): boolean {
        return this._showMap;
    }

    private set showMap(value: boolean) {
        if (this._showMap == value) {
            return;
        }

        this._showMap = value;

        this._weatherContainer.classList.toggle("active", !this._showMap);
        this._mapContainer.classList.toggle("active", this._showMap);

        if (this._showMap) {
            this._map.setAttribute("viewBox", this._mapViewboxActive);
        } else {
            this._map.setAttribute("viewBox", this._mapViewboxSmall);
        }
    }

    private getListData(): VOGalleryList {
        if (this._groupedList) {
            return this._category.blog_kind === "nansen" ? this._data.data.blogs_nansen_grouped : this._data.data.blogs_mosaic_grouped;
        } else {
            return this._category.blog_kind === "nansen" ? this._data.data.blogs_nansen : this._data.data.blogs_mosaic;
        }
    }

    public open(): void {

        // if (this._galleryList)
        //     this._galleryList.reset();
    }

    public reset(): void {
        this.date = this._data.pwa.config.start;
        if (this._galleryList)
            this._galleryList.reset();
        this.showMap = this._data.config.initial_logbook_view == "map";
    }

    public get date(): Date {
        return this._date;
    }

    public set date(date: Date) {
        var sensor = this._data.pwa.getSensorEntry(date, "mosaic");
        date = sensor.date;

        if (this._date.getTime() == date.getTime()) {
            return;
        }

        this._diagram.setDate(date, false);

        this._date = new Date(date);
        for (var route of this._routes) {
            route.setDate(date);
        }

        this._weather.update(date);

        this.element.querySelector(".date-view>.time").textContent = DateUtil.toTimeString(date, Language.current);
        this.element.querySelector(".date-view>.date").textContent = DateUtil.toStringReadableShortLocal(date, Language.current);
        this.element.querySelector(".data-view>.item.temperature>.value").textContent = sensor.temperature.toFixed(1).replace(".", ",");
        this.element.querySelector(".data-view>.item.wind>.value").textContent = sensor.wind.toFixed(1).replace(".", ",");
        this.element.querySelector(".data-view>.item.distance>.value").textContent = Math.round(this._routeMosaic ? this._data.pwa.getDistance(date) : 0) + "";
        this.element.querySelector(".data-view>.item.ice-extent>.value").textContent = (this._data.pwa.getIceExtent(date) / 1000000).toFixed(1).replace(".", ",");

        // this._iceExtentImage.style.backgroundImage = `url(${this._data.pwa.getIceExtentUrl(date)})`;

        var currentIceUrl = this._data.pwa.getIceExtentUrl(date);
        for (var url in this._iceExtentImages) {
            this._iceExtentImages[url].classList.toggle("active", url == currentIceUrl);
        }

        this._onDateChange.dispatch(date);

        if (this._routeMosaic) {
            // console.log(DateUtil.toString(date), this._routeMosaic.distanceLatLng);
            // console.log(this._routeMosaic.point.x, this._routeMosaic.point.y);
            this._point.style.transform = `translate(-50%, -50%) translate(${this._routeMosaic.point.x}px, ${this._routeMosaic.point.y}px)`;
        } else {
            console.warn("No mosaic route");
        }
    }

    private addRoutes(): void {
        var sensors: Sensor[] = [
            this._data.pwa.sensorNansen,
            this._data.pwa.sensorMosaic
        ];

        for (var sensor of sensors) {
            var route = new Route(sensor);
            route.setScale(0.8);
            route.addTo(this._map);
            this._routes.push(route);
            route.setDate(this.date);
        }

        this._routeNansen = this._routes[0];
        this._routeNansen.visible = false;
        this._routeMosaic = this._routes[1];
    }

    private async loadMap(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            $.get(Resource.asset("map.svg"), (data) => {
                this._map = data.documentElement;
                this._map.classList.add("map-svg");

                //Like background-size: cover;
                this._map.setAttribute("preserveAspectRatio", "xMinYMin slice");
                // this._map.setAttribute("viewBox", "0 180 1670 1670");
                this._map.setAttribute("viewBox", this._mapViewboxActive);

                this._mapContainer.prepend(this._map);

                var btn = this.element.querySelector(".live-view-map-corridor-button");
                btn.addEventListener("click", () => {
                    btn.classList.toggle("active");
                    $("#corridor", this._map).toggleClass("active");
                });

                resolve(true);
            });
        });
    }

    private mediaToUngrouped(galleryIndex: number, mediaIndex: number): MediaLookup {
        var galleryList = this._category.blog_kind === "nansen" ? this._data.data.blogs_nansen : this._data.data.blogs_mosaic;
        var galleryListGrouped = this._category.blog_kind === "nansen" ? this._data.data.blogs_nansen_grouped : this._data.data.blogs_mosaic_grouped;
        var mediaId = galleryListGrouped.media[galleryIndex].list_item_medias[mediaIndex].mediaId;

        for (var g of galleryList.media) {
            for (var m of g.list_item_medias) {
                if (m.mediaId === mediaId) {
                    return {
                        galleryIndex: m.gallery.index,
                        mediaIndex: m.index,
                        galleryList: galleryList
                    }
                }
            }
        }

        return null;
    }

    private mediaToGrouped(galleryIndex: number, mediaIndex: number): MediaLookup {
        var galleryList = this._category.blog_kind === "nansen" ? this._data.data.blogs_nansen : this._data.data.blogs_mosaic;
        var galleryListGrouped = this._category.blog_kind === "nansen" ? this._data.data.blogs_nansen_grouped : this._data.data.blogs_mosaic_grouped;
        var mediaId = galleryList.media[galleryIndex].list_item_medias[mediaIndex].mediaId;

        for (var g of galleryListGrouped.media) {
            for (var m of g.list_item_medias) {
                if (m.mediaId === mediaId) {
                    return {
                        galleryIndex: m.gallery.index,
                        mediaIndex: m.index,
                        galleryList: galleryListGrouped
                    }
                }
            }
        }

        return null;
    }

    public async create(category: VOCategory): Promise<boolean> {
        if (!category)
            return false;

        this._category = category;

        this._galleryList.create(this.getListData(), category.show_blog_entries_without_media);

        //When an item in the list is clicked,
        //open the grouped blogs instead of the ungrouped blogs.
        if (!this._groupedList) {
            this._galleryList.filterClick = (galleryIndex, mediaIndex) => {
                return this.mediaToGrouped(galleryIndex, mediaIndex);
            }
        }

        await this.loadMap();

        this.addRoutes();

        this._svgUnderlay = document.createElementNS('http://www.w3.org/2000/svg', "foreignObject");
        this._svgUnderlay.setAttribute('width', "100%");
        this._svgUnderlay.setAttribute('height', "100%");
        this._map.prepend(this._svgUnderlay);

        this._svgOverlay = document.createElementNS('http://www.w3.org/2000/svg', "foreignObject");
        this._svgOverlay.setAttribute('width', "100%");
        this._svgOverlay.setAttribute('height', "100%");
        this._map.appendChild(this._svgOverlay);

        var months = DateUtil.monthDiff(this._data.pwa.config.start, this._data.pwa.config.end);
        var start = new Date(this._data.pwa.config.start);
        for (var i = 0; i < months; ++i) {
            var image = document.createElement("div");
            image.classList.add("ice-extent-image");
            var url = this._data.pwa.getIceExtentUrl(start);
            image.style.backgroundImage = `url(${url})`;
            // this._mapContainer.prepend(image);
            this._svgUnderlay.prepend(image);
            start.setMonth(start.getMonth() + 1);
            this._iceExtentImages[url] = image;
        }

        this._point = document.createElement("div");
        this._point.className = "map-point";
        this._point.innerHTML = "<span class='ring'></span><span class='ring'></span><span class='ring'></span>"

        this._svgOverlay.appendChild(this._point);

        this._diagram.onResize.enabled = true;
        this._diagram.resize();

        this.date = this._data.pwa.config.start;//new Date();

        this.showMap = this._data.config.initial_logbook_view == "map";

        return true;
    }

    public handleClickClose(): boolean {
        return true;
    }

    private projectLatLng(lat: number, lng: number): e5.Point {
        var scaleLat = 2650;
        var offsetLng = 90;
        var pt = e5.Point.polar((360 - lng) + offsetLng, ((90 - lat) / 90) * scaleLat);
        pt.x += this._mapWidth * 0.5;
        pt.y += this._mapHeight * 0.5;
        return pt;
    }
}